import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ProcessIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M3 5C4.10457 5 5 4.10457 5 3C5 1.89543 4.10457 1 3 1C1.89543 1 1 1.89543 1 3C1 4.10457 1.89543 5 3 5Z"
		></path>
		<path
			fill="currentColor"
			d="M13 15C14.1046 15 15 14.1046 15 13C15 11.8954 14.1046 11 13 11C11.8954 11 11 11.8954 11 13C11 14.1046 11.8954 15 13 15Z"
		></path>
		<path
			fill="currentColor"
			d="M11.7497 3.75H6.74973C6.33552 3.75 5.99973 3.41421 5.99973 3C5.99973 2.58579 6.33552 2.25 6.74973 2.25H11.7497C13.5446 2.25 14.9997 3.70507 14.9997 5.5C14.9997 7.21071 13.678 8.61272 12 8.74051V7.23224C12.8479 7.11081 13.4997 6.38152 13.4997 5.5C13.4997 4.5335 12.7162 3.75 11.7497 3.75Z"
		></path>
		<path
			fill="currentColor"
			d="M4 7.25947C2.32189 7.38713 1 8.78919 1 10.5C1 12.2949 2.45507 13.75 4.25 13.75H9.24973C9.66395 13.75 9.99973 13.4142 9.99973 13C9.99973 12.5858 9.66395 12.25 9.24973 12.25H4.25C3.2835 12.25 2.5 11.4665 2.5 10.5C2.5 9.61838 3.15193 8.88903 4 8.76772V7.25947Z"
		></path>
		<path
			fill="currentColor"
			d="M7.62023 5.15731L5.15731 7.62023C4.94756 7.82997 4.94756 8.17003 5.15731 8.37977L7.62023 10.8427C7.82997 11.0524 8.17003 11.0524 8.37977 10.8427L10.8427 8.37977C11.0524 8.17003 11.0524 7.82997 10.8427 7.62023L8.37977 5.15731C8.17003 4.94756 7.82997 4.94756 7.62023 5.15731Z"
		></path>
	</svg>
))
